import { css } from '@emotion/react'
import { baseColors } from 'theme'
const styles = {
  bar: css({
    backgroundColor: baseColors.progressBarBackground,
    height: 8,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    transform: 'skew(-20deg)',
  }),

  completedBar: css({
    height: 8,
    backgroundColor: baseColors.progressBarColor1,
  }),
  splitBarWrapper: css({
    width: '100%',
    justifyContent: 'space-between',
    display: 'flex',
  }),
}

export default styles
